<template>
  <div class="uk-container">
    <template v-if="list.length">
      <div class="uk-width-xlarge uk-margin-auto uk-margin-bottom uk-card uk-card-default uk-card-body uk-padding-small uk-text-center">
        <div class="uk-text-bold">Filters</div>
        <div class="uk-margin-small-top">
          <label class="uk-margin-small-right uk-margin-small-left" for="email-checkbox"><input id="email-checkbox" v-model="filter.new" class="uk-checkbox" type="checkbox"> New</label>
          <label class="uk-margin-small-right uk-margin-small-left" for="sms-checkbox"><input id="sms-checkbox" v-model="filter.progress" class="uk-checkbox" type="checkbox"> In Progress</label>
          <label class="uk-margin-small-right uk-margin-small-left" for="sms-checkbox"><input id="sms-checkbox" v-model="filter.resolved" class="uk-checkbox" type="checkbox"> Resolved</label>
        </div>
      </div>

      <div class="uk-width-xlarge uk-margin-auto uk-card uk-card-default">
        <vue-good-table
          :columns="columns"
          :rows="list"
          :sort-options="{ initialSortBy: {field: 'created', type: 'desc'} }"
          :pagination-options="$globals.vgt.pagination"
          style-class="uk-table uk-table-middle uk-table-divider uk-table-hover uk-margin-remove datatable"
          @on-row-click="onRowClick"
        />
      </div>
    </template>

    <div v-else class="uk-card uk-card-default uk-padding uk-text-center uk-width-large uk-margin-auto">
      There are no requests at the moment!
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewRequestList',

  data() {
    return {
      columns: [
        {
          label: 'Type',
          field: 'type'
        },
        {
          label: 'Date Created',
          field: 'created'
        },
        {
          label: 'Status',
          field: 'status',
          html: true
        }
      ],
      filter: {
        new: true,
        progress: true,
        resolved: false
      }
    }
  },

  computed: {
    list() {
      const source = this.$store.state.requests.collection
      const filters = Object.keys(this.filter).filter(((key) => this.filter[key]))
      const rows = []

      source.forEach((item) => {
        if (filters.includes(item.info.status)) {
          rows.push({
            id: item.id,
            type: this.formatType(item.info.type),
            created: this.$moment(item.info.created.timestamp.seconds, 'X').format('DD/MM/YYYY - HH:mm:ss'),
            status: this.formatStatus(item.info.status)
          })
        }
      })

      return rows
    }
  },

  methods: {
    onRowClick(params) {
      this.$router.push({ name: 'request-single', params: { id: params.row.id } })
    },

    formatType(type) {
      let formatted = 'Error'

      switch (type) {
      case 'dentist':
        formatted = 'Dentist'
        break
      case 'refund':
        formatted = 'Refund'
        break
      default:
        formatted = 'NoMatch'
      }

      return formatted
    },

    formatStatus(data) {
      let label = '<div class="uk-label uk-label-danger">N/A</div>'
      const option = this.$helpers.status.request.find((o) => o.id === data)
      label = `<div class="uk-label uk-label-${option.class}">${option.value}</div>`
      return label
    }
  }
}
</script>
